// 跳外網警告dialog 要這樣呼叫
// window.$openExternal(url, "_blank");

const state = () => ({
  show: false,
  url: "",
  target: "_self",
  pendingWin: null, // ← 預先開好的空白分頁引用
});

const mutations = {
  PROMPT(state, { url, target = "_self" }) {
    state.url = url;
    state.target = target;
    state.show = true;
  },
  RESET(state) {
    state.show = false;
    state.url = "";
    state.target = "_self";
  },
  SET_PENDING_WIN(state, win) {
    state.pendingWin = win;
  },
  CLEAR_PENDING_WIN(state) {
    try {
      state.pendingWin = null;
    } catch (_) {}
  },
};

const actions = {
  prompt({ commit }, payload) {
    commit("PROMPT", payload);
  },
  proceed({ state, commit }) {
    const { url, target } = state;
    commit("RESET");
    // 開啟繞過旗標，避免再次被 guard 攔截
    window.__EXT_GUARD_BYPASS__ = true;
    try {
      if (!target || target === "_self") {
        // 用 href 最穩（我們沒覆寫它）
        window.location.href = url;
      } else {
        window.open(url, target);
      }
    } finally {
      // 新分頁(_blank) 會立即回到這裡；_self 導走也無妨
      setTimeout(() => {
        window.__EXT_GUARD_BYPASS__ = false;
      }, 0);
    }
  },

  cancel({ commit }) {
    commit("RESET");
    // 如果有預開視窗就關掉
    try {
      state.pendingWin && state.pendingWin.close && state.pendingWin.close();
    } catch (_) {}
    commit("CLEAR_PENDING_WIN");
    commit("RESET");
  },
};

export default { namespaced: true, state, mutations, actions };
